export default {"src":"/_next/static/media/exploring_nature.d5d0c5c4.svg","height":94,"width":142,"blurWidth":0,"blurHeight":0};